// Paleta corporativa Agustinos y tema de Ant Design.
// Fuente de verdad de los colores del CMS: cualquier color nuevo sale de aquí.

export const brand = {
  primary: '#e62c19',      // Acciones: crear, editar, primarios, ítem activo del sidebar
  primaryHover: '#c82318', // Estado hover/active del primario
  deep: '#a01a16',         // Identidad: iniciales de sección, tags, kickers del editor
  tint: '#fdeceb',         // Fondo de los tags de sección
  tintBorder: '#f7d3ce',   // Borde de superficies en tinte
  tintSurface: '#fdf1ef',  // Fondo de la acción destacada
  dangerBorder: '#ffd4cf', // Borde de botones destructivos
  onPrimary: '#ffffff',    // Texto e iconos sobre cualquier fondo rojo
};

// Neutros de la maqueta
export const neutral = {
  ink: '#1f2328',       // Títulos
  body: '#3f4550',      // Texto de cuerpo
  muted: '#6b7280',     // Etiquetas
  soft: '#98a1ab',      // Texto terciario
  faint: '#a2a9b1',     // Placeholders
  border: '#e2e5e8',    // Bordes de controles
  borderSoft: '#eceef0',// Bordes de tarjetas
  divider: '#f2f3f5',   // Separadores
  dividerSoft: '#f4f5f6',
  surface: '#ffffff',
  canvas: '#f5f6f7',    // Fondo de página
  fill: '#f4f5f6',      // Rellenos neutros
};

// Colores semánticos de estado: se conservan, no son de marca.
export const statusColors = {
  published: { fg: '#16a34a', bg: '#f0fdf4' },
  scheduled: { fg: '#ea580c', bg: '#fff7ed' },
  draft: { fg: '#5b6470', bg: '#f4f5f6' },
  info: { fg: '#2563eb', bg: '#eff6ff' },
  total: { fg: '#7c3aed', bg: '#f5f3ff' },
};

export const antdTheme = {
  token: {
    colorPrimary: brand.primary,
    colorLink: brand.primary,
    colorLinkHover: brand.primaryHover,
    colorInfo: brand.primary,
    colorSuccess: statusColors.published.fg,
    colorWarning: statusColors.scheduled.fg,
    borderRadius: 8,
    colorTextHeading: neutral.ink,
    colorBorder: neutral.border,
  },
  components: {
    Menu: {
      itemSelectedBg: brand.primary,
      itemSelectedColor: brand.onPrimary,
      itemActiveBg: brand.tint,
      itemHoverBg: brand.tint,
      itemHoverColor: brand.deep,
      itemBorderRadius: 8,
      subMenuItemBg: 'transparent',
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Card: {
      borderRadiusLG: 12,
      colorBorderSecondary: neutral.borderSoft,
    },
    Segmented: {
      itemSelectedBg: neutral.surface,
      trackBg: '#f1f3f5',
    },
  },
};

export default antdTheme;
